import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Chip from '@material-ui/core/Chip';
import TimerIcon from '@material-ui/icons/Timer';
import Timer from './Timer.js';
import moment from 'moment';
require("moment-duration-format");

const maxDuration = 1000 * 60 * 60 * 24 * 7;

const CountUp = (props, context) => {
  const duration = moment.duration(maxDuration - context.remaining + props.offset);
  return (
    <Chip
      style={{ marginRight: 8 }}
      variant="outlined"
      color="primary"
      icon={<TimerIcon />}
      label={`${duration.format("h:mm:ss", { trim: false })}`} />
  );
};
CountUp.propTypes = {
  offset: PropTypes.number,
};
CountUp.contextTypes = {
  remaining: PropTypes.number,
};

class CountUpTimer extends Component {
  constructor(props) {
    super(props);
    this.state = {
      offset: props.startFrom ? moment().diff(props.startFrom) : 0,
    };
  }

  render() {
    return (
      <Timer remaining={maxDuration}>
        <CountUp offset={this.state.offset} />
      </Timer>
    );
  }
}

CountUpTimer.propTypes = {
  startFrom: PropTypes.object,
};

export default CountUpTimer;
